import "core-js/modules/es6.regexp.to-string";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  name: 'barChart',
  props: ['chart'],
  methods: {
    initBarChart: function initBarChart(data, type, val) {
      var title = val;
      console.log(val, 'val');
      var option = {
        title: {
          text: "".concat(title),
          x: 'center',
          y: 'center',
          textStyle: {
            fontSize: 14,
            color: '#ffffff'
          }
        },
        series: [{
          type: 'gauge',
          radius: '50%',
          clockwise: false,
          startAngle: '-80',
          endAngle: '-439.9999',
          splitNumber: 25,
          detail: {
            offsetCenter: [0, -20],
            formatter: ' '
          },
          pointer: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: [[0, '#2CFAFC'], [50 / 100, '#00FFFF'], [1, '#0E192D']],
              width: 30
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            length: 32,
            lineStyle: {
              color: '#0E192D',
              width: 6
            }
          },
          axisLabel: {
            show: false
          }
        }, {
          name: '最内层虚线圈',
          type: 'pie',
          radius: ['44%', '45%'],
          hoverAnimation: false,
          clockWise: false,
          itemStyle: {
            normal: {
              color: 'red'
            }
          },
          label: {
            show: false
          },
          data: setdata()
        }, {
          type: 'pie',
          name: '内层细圆环',
          radius: ['28%', '28.5%'],
          hoverAnimation: false,
          clockWise: false,
          itemStyle: {
            normal: {
              color: '#00FFFF'
            }
          },
          label: {
            show: false
          },
          data: [100]
        }, {
          type: 'pie',
          name: '外层细圆环',
          radius: ['51%', '52%'],
          hoverAnimation: false,
          clockWise: false,
          itemStyle: {
            normal: {
              color: '#00FFFF'
            }
          },
          label: {
            show: false
          },
          data: [100]
        }, {
          name: '大环',
          type: 'gauge',
          splitNumber: 35,
          radius: '72%',
          center: ['50%', '50%'],
          startAngle: 90,
          endAngle: -269.9999,
          axisLine: {
            show: false,
            lineStyle: {
              color: [[1, '#00FFFF']]
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            length: 22,
            lineStyle: {
              color: 'auto',
              width: 2.5
            }
          },
          axisLabel: {
            show: false
          },
          detail: {
            show: false
          }
        }]
      };

      function setdata() {
        var dataArr = [];

        for (var i = 0; i < 100; i++) {
          if (i % 2 === 0) {
            dataArr.push({
              name: (i + 1).toString(),
              value: 10,
              itemStyle: {
                normal: {
                  color: 'rgb(0,255,255,.3)'
                }
              }
            });
          } else {
            dataArr.push({
              name: (i + 1).toString(),
              value: 100,
              itemStyle: {
                normal: {
                  color: 'rgb(0,0,0,0)',
                  borderWidth: 0,
                  borderColor: 'rgba(0,255,255,1)'
                }
              }
            });
          }
        }

        return dataArr;
      }

      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);

      window.onresize = function () {
        myChart.resize();
      };
    } // initBarChart(data, type) {
    //   var that = this
    //   var option = {
    //     grid: {
    //       top: '25%',
    //       left: '3%',
    //       bottom: '5%',
    //       right: '5%',
    //       containLabel: true
    //     },
    //     tooltip: {
    //       show: true
    //     },
    //     animation: false,
    //     xAxis: [
    //       {
    //         type: 'category',
    //         data: data.xData,
    //         axisTick: {
    //           alignWithLabel: true
    //         },
    //         nameTextStyle: {
    //           color: '#82b0ec'
    //         },
    //         axisLine: {
    //           show: false,
    //           lineStyle: {
    //             color: '#82b0ec'
    //           }
    //         },
    //         axisLabel: {
    //           textStyle: {
    //             color: '#fff'
    //           },
    //           margin: 30
    //         }
    //       }
    //     ],
    //     yAxis: [
    //       {
    //         show: false,
    //         type: 'value',
    //         axisLabel: {
    //           textStyle: {
    //             color: '#fff'
    //           }
    //         },
    //         splitLine: {
    //           lineStyle: {
    //             color: '#0c2c5a'
    //           }
    //         },
    //         axisLine: {
    //           show: false
    //         }
    //       }
    //     ],
    //     series: [
    //       {
    //         name: '',
    //         type: 'pictorialBar',
    //         symbolSize: [40, 10],
    //         symbolOffset: [0, -6],
    //         symbolPosition: 'end',
    //         z: 12,
    //         // "barWidth": "0",
    //         label: {
    //           normal: {
    //             show: true,
    //             position: 'top',
    //             // "formatter": "{c}%"
    //             fontSize: 25,
    //             fontWeight: 'bold',
    //             color: '#34DCFF'
    //           }
    //         },
    //         color: '#2DB1EF',
    //         data: data.yData
    //       },
    //       {
    //         name: '',
    //         type: 'pictorialBar',
    //         symbolSize: [40, 10],
    //         symbolOffset: [0, 7],
    //         // "barWidth": "20",
    //         z: 12,
    //         color: '#2DB1EF',
    //         data: data.yData
    //       },
    //       {
    //         name: '',
    //         type: 'pictorialBar',
    //         symbolSize: [50, 15],
    //         symbolOffset: [0, 12],
    //         z: 10,
    //         itemStyle: {
    //           normal: {
    //             color: 'transparent',
    //             borderColor: '#2EA9E5',
    //             borderType: 'solid',
    //             borderWidth: 1
    //           }
    //         },
    //         data: data.yData
    //       },
    //       {
    //         name: '',
    //         type: 'pictorialBar',
    //         symbolSize: [70, 20],
    //         symbolOffset: [0, 18],
    //         z: 10,
    //         itemStyle: {
    //           normal: {
    //             color: 'transparent',
    //             borderColor: '#19465D',
    //             borderType: 'solid',
    //             borderWidth: 2
    //           }
    //         },
    //         data: data.yData
    //       },
    //       {
    //         type: 'bar',
    //         //silent: true,
    //         barWidth: '40',
    //         barGap: '10%', // Make series be overlap
    //         barCateGoryGap: '10%',
    //         itemStyle: {
    //           normal: {
    //             color: new that.$echarts.graphic.LinearGradient(0, 0, 0, 0.7, [
    //               {
    //                 offset: 0,
    //                 color: '#38B2E6'
    //               },
    //               {
    //                 offset: 1,
    //                 color: '#0B3147'
    //               }
    //             ]),
    //             opacity: 0.8
    //           }
    //         },
    //         data: data.yData
    //       }
    //     ]
    //   }
    //   if (type == 'red') {
    //     option.grid = {
    //       left: '6%',
    //       right: '4%',
    //       bottom: '8%',
    //       top:'25%',
    //       containLabel: true
    //     }
    //     option.series = [
    //       {
    //         name: '水质标准',
    //         type: 'pictorialBar',
    //         barCategoryGap: '0%',
    //         symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
    //         label: {
    //           show: true,
    //           position: 'top',
    //           distance: 15,
    //           color: '#4FADFD',
    //           fontWeight: 'bolder',
    //           fontSize: 20
    //         },
    //         itemStyle: {
    //           normal: {
    //             color: {
    //               type: 'linear',
    //               x: 0,
    //               y: 0,
    //               x2: 0,
    //               y2: 1,
    //               colorStops: [
    //                 {
    //                   offset: 0,
    //                   color: '#4FADFD' //  0%  处的颜色
    //                 },
    //                 {
    //                   offset: 1,
    //                   color: '#28E8FA' //  100%  处的颜色
    //                 }
    //               ],
    //               global: false //  缺省为  false
    //             }
    //           },
    //           emphasis: {
    //             opacity: 1
    //           }
    //         },
    //         data: data.yData,
    //         z: 10
    //       }
    //     ]
    //     option.yAxis = [
    //       {
    //         splitNumber: 2,
    //         axisTick: {
    //           show: false
    //         },
    //         axisLine: {
    //           lineStyle: {
    //             color: '#fff',
    //             width: 1 //这里是为了突出显示加上的
    //           }
    //         },
    //         axisLabel: {
    //           textStyle: {
    //             color: '#fff'
    //           }
    //         },
    //         splitArea: {
    //           areaStyle: {
    //             color: 'rgba(255,255,255,.5)'
    //           }
    //         },
    //         splitLine: {
    //           show: true,
    //           lineStyle: {
    //             color: 'rgba(255, 129, 109, 0.1)',
    //             width: 0.5,
    //             type: 'dashed'
    //           }
    //         }
    //       }
    //     ]
    //     option.xAxis = {
    //       data: data.xData,
    //       axisTick: {
    //         alignWithLabel: true
    //       },
    //       axisLabel: {
    //         color: '#fff' //刻度线标签颜色
    //       },
    //       splitLine: {
    //         show: false
    //       },
    //       axisLine: {
    //         lineStyle: {
    //           color: '#fff'
    //         }
    //       }
    //     }
    //   } else if (type == 'two') {
    //     option.legend = {
    //       data: data.legendData,
    //       textStyle: {
    //         color: '#fff'
    //       },
    //       axisLabel: {
    //         color: '#fff' //刻度线标签颜色
    //       }
    //     }
    //     option.xAxis = {
    //       data: data.xData,
    //       axisLine: {
    //         onZero: true,
    //         lineStyle: {
    //           color: '#fff'
    //         }
    //       },
    //       splitLine: { show: false },
    //       splitArea: { show: false },
    //       axisLabel: {
    //         color: '#fff' //刻度线标签颜色
    //       }
    //     }
    //     option.yAxis = {
    //       splitArea: { show: false },
    //       axisLabel: {
    //         color: '#fff' //刻度线标签颜色
    //       },
    //       splitLine: {
    //         show: false
    //       },
    //       axisLine: {
    //         lineStyle: {
    //           color: '#fff'
    //         }
    //       }
    //     }
    //     option.grid = {
    //       left: '4%',
    //       right: '3%',
    //       bottom: '10%',
    //       top: '15%'
    //     }
    //     option.series = [
    //       {
    //         name: '已用设备',
    //         type: 'bar',
    //         stack: 'two',
    //         emphasis: {
    //           itemStyle: {
    //             barBorderWidth: 1,
    //             shadowBlur: 10,
    //             shadowOffsetX: 0,
    //             shadowOffsetY: 0,
    //             shadowColor: 'rgba(0,0,0,0.5)'
    //           }
    //         },
    //         data: data.data1
    //       },
    //       {
    //         name: '所有设备',
    //         type: 'bar',
    //         stack: 'two',
    //         emphasis: {
    //           itemStyle: {
    //             barBorderWidth: 1,
    //             shadowBlur: 10,
    //             shadowOffsetX: 0,
    //             shadowOffsetY: 0,
    //             shadowColor: 'rgba(0,0,0,0.5)'
    //           }
    //         },
    //         data: data.data2
    //       }
    //     ]
    //   }
    //   var chart = this.$refs[this.chart]
    //   var myChart = this.$echarts.init(chart)
    //   myChart.setOption(option)
    //   window.onresize = function() {
    //     myChart.resize()
    //   }
    // }

  }
};